import { configureStore } from '@reduxjs/toolkit';

import snackbarSlice from './reducers/snackbarSlice';
import authReducer from './reducers/authSlice';

import { api } from 'api/api';

export const store = configureStore({
    reducer: {
        snackbar: snackbarSlice,
        auth: authReducer,
        [api.reducerPath]: api.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
});

const state = store.getState();

export type AppDispatch = typeof store.dispatch;

export type RootState = {
    [k in keyof typeof state]: typeof state[k]
}
